// カードを新規追加するモーダルのコンポーネント

import React, { useState } from 'react';

import './NewCardSettingModal.css';

// React Modalで実装
import Modal from 'react-modal';

import NewCardSetting1 from './NewCardSetting1';
import NewCardSetting2 from './NewCardSetting2';
import { useEffect } from 'react';

const NewCardSettingModal = ({ modalIsOpen, closeModal, currentCard, setCurrentCard, selectedOption, setSelectedOption, packageInfo, cardList, setCardList, cardNumber, setCardNumber, setTotalRefundPoint}) => {
    const [newCardSettingPage, setNewCardSettingPage] = useState(1);
    const [previewImage, setPreviewImage] = useState();
    
    const moveNextPage = () => {
        setNewCardSettingPage(2);
    }

    const movePrevPage = () => {
        setCurrentCard({...currentCard, prev: true});
        setNewCardSettingPage(1);
    }

    const closeAndResetModal = () => {
        closeModal();
        setNewCardSettingPage(1);
        setSelectedOption('1');
        setPreviewImage();
        setCurrentCard({...currentCard, update: false});
    }

    const saveCard = () => {
        let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
        if (xsrfToken) {
            xsrfToken = xsrfToken.split('=')[1]
        }
        let token = document.cookie.split('; ').find(row => row.startsWith('token'));
        if (token) {
            token = token.split('=')[1]
        }
        
        if (selectedOption === "1") {
            let url = process.env.REACT_APP_API_URL + '/api/package-card/register';
            if (currentCard.id) {
                url = process.env.REACT_APP_API_URL + '/api/package-card/update/' + currentCard.id;
            }

            fetch(url, {
                method: 'POST',
                cache: 'no-store',
                headers: {
                    'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
                    'Bearer': decodeURIComponent(token),
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify({
                    card_id: currentCard.card_id ? currentCard.card_id : null,
                    name: currentCard.name,
                    rank: currentCard.rank,
                    number: currentCard.number,
                    stock: currentCard.stock,
                    point: currentCard.rewardPoint,
                    psa: currentCard.psa ? currentCard.psa : 0,
                    is_psa_enabled: currentCard.isPsaEnabled,
                    type: packageInfo.packageType,
                    package_id: packageInfo.packageId,
                })
            })
            .then(response => {
                if (!response.ok) {
                    // data.messageにエラーメッセージが入っている
                    return response.json().then(data => {
                        throw new Error(data.message);
                    });
                }
                return response.json();
            })
            .then(data => {
                if(!data.errors) {
                    closeModal();
                    setNewCardSettingPage(1);
                    setSelectedOption('1');
                    setPreviewImage();

                    if (currentCard.id) {
                        let newCardList = cardList.map((card) => {
                            if (card.id === currentCard.id) {
                                return {
                                    url: process.env.REACT_APP_ASSET_URL + data.package_card.image_url,
                                    name: data.package_card.name,
                                    rank: data.package_card.rank,
                                    number: data.package_card.number,
                                    stock: data.package_card.stock,
                                    rewardPoint: data.package_card.point,
                                    isPsaEnabled: data.package_card.is_psa_enabled,
                                    psa: data.package_card.psa,
                                    card_id: data.package_card.card_id,
                                    id: currentCard.id,
                                }
                            } else {
                                return card;
                            }
                        });
                        setCardList(newCardList);
                        // let newCardNumber = cardNumber - currentCard.number + parseInt(data.package_card.number);
                        // setCardNumber(newCardNumber);
                    } else {
                        let packageCard = data.package_card;
                        // setCardNumber(cardNumber + parseInt(packageCard.number));
                        setCardList([...cardList, {
                            url: process.env.REACT_APP_ASSET_URL + packageCard.image_url,
                            name: packageCard.name,
                            rank: packageCard.rank,
                            number: packageCard.number,
                            stock: packageCard.stock,
                            rewardPoint: packageCard.point,
                            isPsaEnabled: data.package_card.is_psa_enabled,
                            psa: data.package_card.psa,
                            card_id: packageCard.card_id,
                            id: packageCard.id,
                        }]);
                    }
                } else {
                    alert(Object.values(data.errors)[0]);
                }
            })
            .catch(error => {
                alert(error.message);
                console.error(error);
            });
        } else if (selectedOption === "2") {
            const body = new FormData();
            if(currentCard.id) {
                body.append('id', currentCard.id);
            }
            body.append('image', currentCard.image);
            body.append('name', currentCard.name);
            body.append('rank', currentCard.rank);
            body.append('number', currentCard.number);
            body.append('point', currentCard.rewardPoint);
            body.append('psa', currentCard.psa ? currentCard.psa : 0);
            body.append('is_psa_enabled', currentCard.isPsaEnabled);
            body.append('type', packageInfo.packageType);
            body.append('package_id', packageInfo.packageId);

            let url = process.env.REACT_APP_API_URL + '/api/package-card/register-with-file';
            if (currentCard.id) {
                url = process.env.REACT_APP_API_URL + '/api/package-card/update-with-file'
            }

            fetch(url, {
                method: 'POST',
                cache: 'no-store',
                headers: {
                    'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
                    'Bearer': decodeURIComponent(token)
                },
                credentials: 'include',
                body,
            })
            .then(response => {
                if (!response.ok) {
                    // data.messageにエラーメッセージが入っている
                    return response.json().then(data => {
                        throw new Error(data.message);
                    });
                }
                return response.json();
            })
            .then(data => {
                if(!data.errors) {
                    closeModal();
                    setNewCardSettingPage(1);
                    setSelectedOption('1');
                    setPreviewImage();

                    if (currentCard.id) {
                        let newCardList = cardList.map((card) => {
                            if (card.id === currentCard.id) {
                                return {
                                    url: process.env.REACT_APP_ASSET_URL + data.package_card.image_url,
                                    name: data.package_card.name,
                                    rank: data.package_card.rank,
                                    number: data.package_card.number,
                                    stock: data.package_card.stock,
                                    rewardPoint: data.package_card.point,
                                    card_id: data.package_card.card_id,
                                    id: currentCard.id,
                                }
                            } else {
                                return card;
                            }
                        });
                        setCardList(newCardList);
                        // let newCardNumber = cardNumber - currentCard.number + parseInt(data.package_card.number);
                        // setCardNumber(newCardNumber);
                    } else {
                        let packageCard = data.package_card;
                        // setCardNumber(cardNumber + parseInt(packageCard.number));
                        setCardList([...cardList, {
                            url: process.env.REACT_APP_ASSET_URL + packageCard.image_url,
                            name: packageCard.name,
                            rank: packageCard.rank,
                            number: packageCard.number,
                            stock: packageCard.stock,
                            rewardPoint: packageCard.point,
                            card_id: packageCard.card_id,
                            id: packageCard.id,
                        }]);
                    }
                } else {
                    alert(Object.values(data.errors)[0]);
                }
            })
            .catch(error => {
                alert(error.message);
                console.error(error);
            });
        } else if (selectedOption === "3") {
            let url = process.env.REACT_APP_API_URL + '/api/package-card/register-with-url';
            if (currentCard.id) {
                url = process.env.REACT_APP_API_URL + '/api/package-card/update-with-url'
            }

            fetch(url, {
                method: 'POST',
                cache: 'no-store',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
                    'Bearer': decodeURIComponent(token)
                },
                credentials: 'include',
                body: JSON.stringify({
                    id: currentCard.id,
                    card_id: currentCard.card_id ? currentCard.card_id : null,
                    package_id: packageInfo.id,
                    image: currentCard.image,
                    name: currentCard.name,
                    rank: currentCard.rank,
                    number: currentCard.number,
                    point: currentCard.rewardPoint,
                    psa: currentCard.psa ? currentCard.psa : 0,
                    is_psa_enabled: currentCard.isPsaEnabled,
                    type: packageInfo.packageType,
                    package_id: packageInfo.packageId,
                }),
            })
            .then(response => {
                if (!response.ok) {
                    // data.messageにエラーメッセージが入っている
                    return response.json().then(data => {
                        throw new Error(data.message);
                    });
                }
                return response.json();
            })
            .then(data => {
                if(!data.errors) {
                    closeModal();
                    setNewCardSettingPage(1);
                    setSelectedOption('1');
                    setPreviewImage();

                    if (currentCard.id) {
                        let newCardList = cardList.map((card) => {
                            if (card.id === currentCard.id) {
                                return {
                                    url: process.env.REACT_APP_ASSET_URL + data.package_card.image_url,
                                    name: data.package_card.name,
                                    rank: data.package_card.rank,
                                    number: data.package_card.number,
                                    stock: data.package_card.stock,
                                    rewardPoint: data.package_card.point,
                                    card_id: data.package_card.card_id,
                                    id: currentCard.id,
                                }
                            } else {
                                return card;
                            }
                        });
                        setCardList(newCardList);
                        // let newCardNumber = cardNumber - currentCard.number + parseInt(data.package_card.number);
                        // setCardNumber(newCardNumber);
                    } else {
                        let packageCard = data.package_card;
                        // setCardNumber(cardNumber + parseInt(packageCard.number));
                        setCardList([...cardList, {
                            url: process.env.REACT_APP_ASSET_URL + packageCard.image_url,
                            name: packageCard.name,
                            rank: packageCard.rank,
                            number: packageCard.number,
                            stock: packageCard.stock,
                            rewardPoint: packageCard.point,
                            card_id: packageCard.card_id,
                            id: packageCard.id,
                        }]);
                    }
                } else {
                    alert(Object.values(data.errors)[0]);
                }
            })
            .catch(error => {
                alert(error.message);
                console.error(error);
            });
        }
    }

    useEffect(() => {
        setCardNumber(cardList.filter((card) => card.rank != 9).reduce((acc, card) => {
            return acc + parseInt(card.number);
        }, 0));
        setTotalRefundPoint(cardList.reduce((acc, card) => {
            if (card.rank == 9) {
                return acc + parseInt(card.rewardPoint);
            }
            return acc + parseInt(card.number) * parseInt(card.rewardPoint);
        }, 0));
    }, [cardList]);

    Modal.setAppElement('#root');

    return (
        <>
            { newCardSettingPage === 1 &&
                <>
                    <NewCardSetting1 
                        modalIsOpen = {modalIsOpen}
                        closeModal = {closeAndResetModal}
                        moveNextPage = {moveNextPage}
                        currentCard={currentCard}
                        setCurrentCard={setCurrentCard}
                        selectedOption={selectedOption}
                        setSelectedOption={setSelectedOption}
                        previewImage={previewImage}
                        setPreviewImage={setPreviewImage}
                        packageInfo={packageInfo}
                    />
                </>
            }
            { newCardSettingPage === 2 &&
                <>
                    <NewCardSetting2
                        modalIsOpen = {modalIsOpen}
                        closeModal = {closeAndResetModal}
                        movePrevPage = {movePrevPage}
                        currentCard={currentCard}
                        setCurrentCard={setCurrentCard}
                        selectedOption={selectedOption}
                        previewImage={previewImage}
                        saveCard={saveCard}
                    />
                </>
            }
        </>
    );
}

export default NewCardSettingModal;